import React from "react";
import { Link } from "react-router-dom";
import { WhatsAppCTA, OutlineButton } from "../components/Buttons";

export default function NotFound() {
  return (
    <section className="relative bg-ink text-paper min-h-[80vh] overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-60" aria-hidden />
      <div className="absolute inset-0 bg-glow-radial" aria-hidden />
      <div className="relative max-w-site mx-auto px-6 md:px-12 lg:px-16 pt-32 md:pt-44 pb-32 flex flex-col items-start justify-center min-h-[80vh]">
        <div className="font-mono text-[12px] tracking-[0.22em] uppercase text-voltage mb-7">
          404 / Page not found
        </div>
        <h1 className="font-display font-semibold text-[64px] md:text-[96px] leading-[1.02] tracking-[-0.03em] max-w-3xl">
          That page doesn&rsquo;t exist.
        </h1>
        <p className="mt-7 text-paper/70 text-lg md:text-xl max-w-xl leading-relaxed">
          The link may be outdated, or the page has moved.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-5">
          <WhatsAppCTA testId="nf-whatsapp-cta" />
          <OutlineButton as={Link} to="/" withArrow testId="nf-home-link">
            Return home
          </OutlineButton>
        </div>
      </div>
    </section>
  );
}
